import { render, staticRenderFns } from "./TeacherAdd.vue?vue&type=template&id=2522bf6e&"
import script from "./TeacherAdd.vue?vue&type=script&lang=js&"
export * from "./TeacherAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports